(() => {
  const root = document.querySelector("[data-ph-catalog]");

  if (!root || !Array.isArray(window.PH_CATALOG_DATA)) return;

  /* =========================================================
     NORMALIZACIÓN
     ========================================================= */

  const normalize = (value) =>
    String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();


  /* =========================================================
     ALIAS DE BÚSQUEDA
     ========================================================= */

  const aliases = {
    savage: "sauvage",
    bacara: "baccarat",
    bacarat: "baccarat",
    br540: "baccarat rouge 540",
    invictuz: "invictus",
    ysl: "yves saint laurent",
    tomford: "tom ford"
  };


  /* =========================================================
     ICONOS DE GÉNERO
     ========================================================= */

  const genderIcon = {
    Dama: "👩",
    Caballero: "👨",
    Unisex: "◌"
  };


  /* =========================================================
     🔥 LOS MÁS VENDIDOS PH
     El orden aquí es el orden en el que se mostrarán.
     ========================================================= */

  const bestSellerUrls = [
    "/products/perfume-santal-33-de-60-ml",
    "/products/perfume-sauvage-de-60-ml-1",
    "/products/perfume-bacarat-rouge-540-de-60-ml",
    "/products/perfume-la-vie-est-belle-de-60-ml",
    "/products/perfume-good-girl-de-60-ml",
    "/products/perfume-acqua-di-gio-de-60-ml",
    "/products/perfume-ombre-nomade-de-60-ml",
    "/products/perfume-imagination-de-60-ml",
    "/products/perfume-cloud-de-60-ml",
    "/products/perfume-sweet-like-candy-de-60-ml",
    "/products/perfume-bharara-king-de-60-ml",
    "/products/perfume-erba-pura-unisex-de-60-ml",
    "/products/perfume-212-vip-men-de-60-ml"
  ];

  const bestSellerSet = new Set(bestSellerUrls);

  const bestSellerOrder = new Map(
    bestSellerUrls.map((url, index) => [url, index])
  );


  /* =========================================================
     PERFUMES MANUALES
     ========================================================= */

  const manualNode = root.querySelector("[data-ph-catalog-manual]");

  let manualText = "";

  try {
    manualText = JSON.parse(manualNode?.textContent || '""') || "";
  } catch (_) {
    manualText = "";
  }

  const manualItems = String(manualText)
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line, index) => {
      const parts = line
        .split("|")
        .map((part) => part.trim());

      const [
        name,
        brand = "",
        gender = "Sin clasificar",
        category = "Diseñador",
        url = ""
      ] = parts;

      return {
        name,
        brand,
        gender,
        category,
        url,
        status: url ? "Publicado" : "Consultar",
        sku: `MANUAL-${index + 1}`,
        source: "Manual"
      };
    })
    .filter((item) => item.name);


  /* =========================================================
     PREPARAR CATÁLOGO
     ========================================================= */

  const seen = new Set();

  const items = [
    ...window.PH_CATALOG_DATA,
    ...manualItems
  ]
    .filter((item) => {

      /*
        No usamos solamente el nombre porque existen perfumes
        con el mismo nombre para Dama y Caballero.
        Ejemplo: Light Blue y The One.
      */

      const key = item.url
        ? normalize(item.url)
        : `${normalize(item.name)}|${normalize(item.gender)}|${normalize(item.brand)}`;

      if (!key || seen.has(key)) return false;

      seen.add(key);

      item.search = normalize(
        [
          item.name,
          item.brand,
          item.gender,
          item.category,
          item.sku
        ].join(" ")
      );

      return true;
    })
    .sort((a, b) =>
      a.name.localeCompare(
        b.name,
        "es",
        { sensitivity: "base" }
      )
    );


  /* =========================================================
     ELEMENTOS DEL DOM
     ========================================================= */

  const input =
    root.querySelector("[data-ph-catalog-search]");

  const clear =
    root.querySelector("[data-ph-catalog-clear]");

  const results =
    root.querySelector("[data-ph-catalog-results]");

  const empty =
    root.querySelector("[data-ph-catalog-empty]");

  const emptyWhatsApp =
    root.querySelector("[data-ph-empty-whatsapp]");

  const count =
    root.querySelector("[data-ph-catalog-count]");

  const filterRail =
    root.querySelector("[data-ph-catalog-filters]");

  const prev =
    root.querySelector("[data-ph-filter-prev]");

  const next =
    root.querySelector("[data-ph-filter-next]");

  const filterButtons = [
    ...root.querySelectorAll("[data-filter]")
  ];

  const moreWrap =
    root.querySelector("[data-ph-catalog-more-wrap]");

  const moreButton =
    root.querySelector("[data-ph-catalog-more]");

  const whatsapp =
    String(root.dataset.whatsapp || "")
      .replace(/\D/g, "");

  const fallbackWhatsApp =
    String(root.dataset.whatsappFallback || "");

  const BATCH_SIZE = 48;

  let activeFilter = "all";

  let visibleLimit = BATCH_SIZE;


  /* =========================================================
     ESCAPAR HTML
     ========================================================= */

  const escapeHtml = (value) =>
    String(value || "")
      .replace(
        /[&<>"']/g,
        (char) => ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#039;"
        })[char]
      );


  /* =========================================================
     WHATSAPP
     ========================================================= */

  const consultUrl = (name) => {

    const text = encodeURIComponent(
      `Hola, vi ${name} en el catálogo de PH y quisiera más información.`
    );

    return whatsapp
      ? `https://wa.me/${whatsapp}?text=${text}`
      : fallbackWhatsApp || "/pages/contacto";
  };

  function resetVisibleLimit() {
    visibleLimit = BATCH_SIZE;
  }

  function updateMoreButton(total, visible) {
    if (!moreWrap || !moreButton) return;

    const remaining = Math.max(0, total - visible);
    moreWrap.hidden = remaining === 0;
    if (!remaining) return;

    moreButton.textContent =
      `Mostrar más aromas · ${remaining} restantes`;
    moreButton.setAttribute(
      "aria-label",
      `Mostrar ${Math.min(BATCH_SIZE, remaining)} aromas más. ${remaining} restantes.`
    );
  }


  /* =========================================================
     FLECHAS DE FILTROS
     ========================================================= */

  function updateArrows() {

    if (!filterRail || !prev || !next) return;

    const max = Math.max(
      0,
      filterRail.scrollWidth -
      filterRail.clientWidth
    );

    prev.classList.toggle(
      "is-visible",
      filterRail.scrollLeft > 8
    );

    next.classList.toggle(
      "is-visible",
      filterRail.scrollLeft < max - 8
    );
  }


  if (prev && filterRail) {
    prev.addEventListener(
      "click",
      () =>
        filterRail.scrollBy({
          left: -190,
          behavior: "smooth"
        })
    );
  }


  if (next && filterRail) {
    next.addEventListener(
      "click",
      () =>
        filterRail.scrollBy({
          left: 190,
          behavior: "smooth"
        })
    );
  }


  if (filterRail) {
    filterRail.addEventListener(
      "scroll",
      updateArrows,
      { passive: true }
    );
  }


  window.addEventListener(
    "resize",
    updateArrows,
    { passive: true }
  );


  /* =========================================================
     CREAR HTML DE UN PERFUME
     ========================================================= */

  function itemTemplate(item) {

    const href =
      item.url ||
      consultUrl(item.name);

    const label =
      item.url
        ? "Ver perfume"
        : "Consultar";

    const icon =
      genderIcon[item.gender] || "•";

    return `
      <article class="ph-catalog__item">

        <div class="ph-catalog__item-main">

          <span class="ph-catalog__item-name">
            ${escapeHtml(item.name)}
          </span>

          ${
            item.brand
              ? `
                <span class="ph-catalog__brand">
                  ${escapeHtml(item.brand)}
                </span>
              `
              : ""
          }

          <div class="ph-catalog__meta">

            <span>
              ${icon} ${escapeHtml(item.gender)}
            </span>

            ${
              item.category !== "Diseñador"
                ? `
                  <span class="ph-catalog__dot">•</span>

                  <span>
                    ${escapeHtml(item.category)}
                  </span>
                `
                : ""
            }

          </div>

        </div>

        <a
          class="ph-catalog__action"
          href="${escapeHtml(href)}"
          ${
            item.url
              ? ""
              : 'target="_blank" rel="noopener"'
          }
        >
          ${label} →
        </a>

      </article>
    `;
  }


  /* =========================================================
     RENDER
     ========================================================= */

  function render() {

    let query = normalize(input?.value);

    query =
      aliases[query] ||
      query;


    if (input) {

      const searchBox =
        input.closest(
          ".ph-catalog__search"
        );

      if (searchBox) {
        searchBox.classList.toggle(
          "has-value",
          Boolean(input.value)
        );
      }
    }


    let filtered = items.filter((item) => {

      const matchesQuery =
        !query ||
        item.search.includes(query);


      let matchesFilter = false;


      if (activeFilter === "all") {

        matchesFilter = true;

      } else if (
        activeFilter === "bestsellers"
      ) {

        matchesFilter =
          bestSellerSet.has(item.url);

      } else {

        matchesFilter =
          item.gender === activeFilter ||
          item.category === activeFilter;
      }


      return (
        matchesQuery &&
        matchesFilter
      );
    });


    /* =======================================================
       ORDEN ESPECIAL PARA LOS MÁS VENDIDOS
       ======================================================= */

    if (
      activeFilter === "bestsellers"
    ) {

      filtered.sort(
        (a, b) =>
          (bestSellerOrder.get(a.url) ?? 999) -
          (bestSellerOrder.get(b.url) ?? 999)
      );
    }


    /* =======================================================
       CONTADOR Y ESTADO VACÍO
       ======================================================= */

    if (count) {
      count.textContent =
        filtered.length;
    }


    if (results) {
      results.hidden =
        filtered.length === 0;
    }


    if (empty) {
      empty.hidden =
        filtered.length !== 0;
    }


    if (!filtered.length) {

      updateMoreButton(0, 0);

      if (emptyWhatsApp) {

        emptyWhatsApp.href =
          consultUrl(
            input?.value.trim() ||
            "un aroma"
          );
      }


      if (results) {
        results.innerHTML = "";
      }

      return;
    }

    const visibleItems =
      activeFilter === "bestsellers"
        ? filtered
        : filtered.slice(0, visibleLimit);

    updateMoreButton(
      filtered.length,
      visibleItems.length
    );


    /* =======================================================
       BEST SELLERS
       No agrupamos por letra.
       Respetamos el ranking.
       ======================================================= */

    if (
      activeFilter === "bestsellers"
    ) {

      results.innerHTML = `
        <section class="ph-catalog__letter ph-catalog__letter--bestsellers">

          <div class="ph-catalog__letter-title">
            🔥
          </div>

          <div class="ph-catalog__list">

            ${visibleItems
              .map(itemTemplate)
              .join("")}

          </div>

        </section>
      `;

      return;
    }


    /* =======================================================
       CATÁLOGO NORMAL AGRUPADO POR LETRAS
       ======================================================= */

    const groups =
      visibleItems.reduce(
        (acc, item) => {

          const letter =
            normalize(item.name)
              .charAt(0)
              .toUpperCase() ||
            "#";

          (acc[letter] ||= [])
            .push(item);

          return acc;
        },
        {}
      );


    results.innerHTML =
      Object.entries(groups)
        .map(
          ([letter, group]) => `

            <section class="ph-catalog__letter">

              <div class="ph-catalog__letter-title">
                ${escapeHtml(letter)}
              </div>

              <div class="ph-catalog__list">

                ${group
                  .map(itemTemplate)
                  .join("")}

              </div>

            </section>

          `
        )
        .join("");
  }


  /* =========================================================
     BUSCADOR
     ========================================================= */

  if (input) {

    input.addEventListener(
      "input",
      () => {
        resetVisibleLimit();
        render();
      }
    );
  }


  if (clear && input) {

    clear.addEventListener(
      "click",
      () => {

        input.value = "";

        input.focus();

        resetVisibleLimit();

        render();
      }
    );
  }


  /* =========================================================
     FILTROS
     ========================================================= */

  filterButtons.forEach(
    (button) => {

      button.addEventListener(
        "click",
        () => {

          activeFilter =
            button.dataset.filter;

          resetVisibleLimit();


          filterButtons.forEach(
            (item) => {

              item.classList.toggle(
                "is-active",
                item === button
              );
            }
          );


          render();
        }
      );
    }
  );

  if (moreButton) {
    moreButton.addEventListener(
      "click",
      () => {
        visibleLimit += BATCH_SIZE;
        render();
      }
    );
  }


  /* =========================================================
     PLACEHOLDERS ROTATIVOS
     ========================================================= */

  const rotatingNames =
    String(
      input?.dataset.placeholders ||
      ""
    )
      .split(",")
      .map(
        (item) =>
          item.trim()
      )
      .filter(Boolean);


  let placeholderIndex = 0;

  let placeholderTimer = null;


  function startPlaceholders() {

    if (
      !input ||
      !rotatingNames.length ||
      document.activeElement === input ||
      input.value
    ) {
      return;
    }


    window.clearInterval(
      placeholderTimer
    );


    input.placeholder =
      `Ej. ${rotatingNames[placeholderIndex]}`;


    placeholderTimer =
      window.setInterval(
        () => {

          if (
            document.activeElement === input ||
            input.value
          ) {
            return;
          }


          placeholderIndex =
            (
              placeholderIndex + 1
            ) %
            rotatingNames.length;


          input.placeholder =
            `Ej. ${rotatingNames[placeholderIndex]}`;

        },
        2500
      );
  }


  if (input) {

    input.addEventListener(
      "focus",
      () => {

        window.clearInterval(
          placeholderTimer
        );


        if (!input.value) {

          input.placeholder =
            "¿Qué perfume buscas?";
        }
      }
    );


    input.addEventListener(
      "blur",
      startPlaceholders
    );
  }


  /* =========================================================
     INICIO
     ========================================================= */

  render();

  requestAnimationFrame(
    updateArrows
  );

  startPlaceholders();

})();
